"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Testimonial } from "./testimonial";
import { useV2Translation } from "@/lib/i18n/use-v2-translation";

export const FAQ = () => {
  const { t } = useV2Translation();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 lg:py-32 border-t border-line"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 lg:gap-10">
          <div className="col-span-12 lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
            <h2
              data-testid="faq-headline"
              className="font-display font-normal text-4xl lg:text-5xl leading-[1.06] tracking-tight"
            >
              {t.faq.headline}{" "}
              <span className="italic text-gold">{t.faq.highlight}</span>
            </h2>
            <p className="font-body text-base text-ink/70 mt-6 max-w-[34ch]">
              {t.faq.subtitle}
            </p>
          </div>

          <div className="col-span-12 lg:col-span-8 lg:col-start-5">
            <Testimonial
              index={3}
              quoteTitle={t.faq.testimonial3.quoteTitle}
              body={t.faq.testimonial3.body}
              author={t.faq.testimonial3.author}
              role={t.faq.testimonial3.role}
            />

            <Accordion
              type="single"
              collapsible
              data-testid="faq-accordion"
              className="border-t border-ink/20 mt-14"
            >
              {t.faq.items.map((f, i) => {
                const num = String(i + 1).padStart(2, "0");
                return (
                  <AccordionItem
                    key={i}
                    value={`item-${i}`}
                    data-testid={`faq-item-${i + 1}`}
                    className="border-b border-ink/20"
                  >
                    <AccordionTrigger
                      data-testid={`faq-trigger-${i + 1}`}
                      className="py-7 hover:no-underline group"
                    >
                      <div className="flex items-start gap-6 text-left flex-1 pr-4">
                        <span className="font-mono text-xs text-gold mt-1 shrink-0">
                          Q.{num}
                        </span>
                        <span className="font-display text-xl lg:text-2xl leading-tight tracking-tight text-ink group-hover:text-gold transition-colors">
                          {f.q}
                        </span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent
                      data-testid={`faq-content-${i + 1}`}
                      className="pb-8 pl-[3.25rem] pr-4"
                    >
                      <p className="font-body text-base lg:text-lg leading-relaxed text-ink/80 max-w-[64ch]">
                        {f.a}
                      </p>
                    </AccordionContent>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
